import { Button } from '@material-ui/core'
import React from 'react'

import { appConfig } from '../config'

interface IProps {}

export const ContactButton: React.FC<IProps> = props => {
  return (
    <Button href={`mailto:${appConfig.supportEmail}`}>kontaktujte nás</Button>
  )
}
